import React from "react"

import { localizer } from '../../../../Translator.js'

import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import { Badge, DialogTitle, TableRow } from "@material-ui/core"
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Grid from '@material-ui/core/Grid'
import Button from "@material-ui/core/Button"
import { Alert, AlertTitle } from '@material-ui/lab';
import Tooltip from '@material-ui/core/Tooltip';

import { FeatureModal } from "./FeatureModal.js"

import { TextFieldStyled } from "../../../common/InputStyled.js"

import { TableCellStyled, TableRowStyled } from '../../../common/TableStyled.js'
import TooltipStyled from "../../../common/TooltipStyled.js"

import { SnackbarCustom } from "../../../Utilities/SnackbarCustom.js"
import CurrencyCustom from "../../../Utilities/CurrencyCustom.js"
import EmailValidator from "../../../Utilities/EmailValidator.js"

import OutboxCli from "../../../../sdk/OutboxCli.js"


/**
 * Form to select shipment features.
 */
export class FeatureRow extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      // to OCR: rectangle in draft
      document: null,
      referenceLeft: 11,
      referenceTop: 17,
      referenceWidth: 26,
      referenceHeight: 6,

      // Third party email
      thirdPartyEmail: null,
      repeatThirdPartyEmail: null,

      // OCR errors
      message: null,
      severity: "error",

      // OCR modal
      openOcrReferenceModal: false,

      // Third party email modal flag
      openThirdPartyEmailModal: false,

      // Shipment object which it is gonna be display to set its features
      shipment: {},

      // These flag indicates if page options menu must be opened or closed
      optionsMenu: null,
      openMenu: false,
    }
  }

  /**
  * Updates the current state with the features data from the parent component state
  */
  componentDidMount() {
    let left = 11
    let top = 17
    let width = 26
    let height = 6
    if (this.props.billable && this.props.billable.referenceBox && this.validateBoxSelector(this.props.billable.referenceBox)) {
      left = this.props.billable.referenceBox.left
      top = this.props.billable.referenceBox.top
      width = this.props.billable.referenceBox.width
      height = this.props.billable.referenceBox.height
    }
    
    this.setState({
      shipment: this.props.shipment,
      referenceLeft: left,
      referenceTop: top,
      referenceWidth: width,
      referenceHeight: height,

      thirdPartyEmail: this.props.shipment.features ? this.props.shipment.features.notifyToThirdParty : null,
      repeatThirdPartyEmail: this.props.shipment.features ? this.props.shipment.features.notifyToThirdParty : null,
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.shipment === this.props.shipment) return

    let left = 11
    let top = 17
    let width = 26
    let height = 6
    
    if (this.props.billable && this.props.billable.referenceBox && this.validateBoxSelector(this.props.billable.referenceBox)) {
      left = this.props.billable.referenceBox.left
      top = this.props.billable.referenceBox.top
      width = this.props.billable.referenceBox.width
      height = this.props.billable.referenceBox.height
    }
    
    this.setState({
      shipment: this.props.shipment,
      referenceLeft: left,
      referenceTop: top,
      referenceWidth: width,
      referenceHeight: height,

      thirdPartyEmail: this.props.shipment.features ? this.props.shipment.features.notifyToThirdParty : null,
      repeatThirdPartyEmail: this.props.shipment.features ? this.props.shipment.features.notifyToThirdParty : null,
    })
  }

  /* check if the box is valid to take its coordinates
   * It is defined but some of its coordinates are missing
   * Some of its coordinates are negative
   * The defined area is zero (a line, a point
  */
  validateBoxSelector = (Box) => {
    if (!Box.width || !Box.height || !Box.left || !Box.top) return false
    if (Box.width < 0 || Box.height < 0 || Box.left < 0 || Box.top < 0) return false
    if (Box.width === 0 || Box.height === 0 || (Box.left === Box.top)) return false
    
    return true
  }

  
  /**
   * Handler onChange event for every input to update the current state
   */
  onInputChange = (event) => {
    var value = event.target.value
    var reference = this.MultiSpace(value.replace("\t", " "), " ")

    this.setState(previousState => ({
      shipment: {
        ...previousState.shipment,
        features: {
          ...previousState.shipment.features,
          reference: reference
        }
      }
    }), () => { this.props.handleFeatures(this.state.shipment, this.props.index) })
  }

  // Handler onChange event for notifyToThirdParty input
  onInputThirdEmailChange = (event) => { this.setState({ thirdPartyEmail: event.target.value }) }
  onInputRepeatThirdEmailChange = (event) => { this.setState({ repeatThirdPartyEmail: event.target.value }) }

  /* Request for Base64 of the first draft page when Detect Reference Modal opens */
  doOpenOcrReferenceModal = () => {
    let draftid = this.state.shipment && this.state.shipment.pages.length > 0 ? this.state.shipment.pages[0].draftId : null
    let pageFirst = this.state.shipment && this.state.shipment.pages.length > 0 ? this.state.shipment.pages[0].pageFirst : 1
    if (!draftid) return this.setState({ message: localizer.BoxSelectorNoDocument, severity: "error" })

    OutboxCli.GetDraftPageImage(draftid,
      pageFirst,
      0,
      0,
      100,
      100
    ).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ message: response.substring(response.indexOf(' ')), severity: "error" })
      } else {
        this.setState({ document: response, openOcrReferenceModal: true })
      }
    })
  }
  
  doCloseOcrReferenceModal = () => { this.setState({ openOcrReferenceModal: false }) }
  doCloseThirdPartyEmailModal = () => { this.setState({ openThirdPartyEmailModal: false }) }

  doAcceptThirdPartyEmail = () => {
    let errors = []
    let error = EmailValidator.isValidEmail(this.state.thirdPartyEmail)
    if (error) errors.push(error)
    
    error = EmailValidator.equalEmails(this.state.thirdPartyEmail, this.state.repeatThirdPartyEmail)
    if (error) errors.push(error)
    
    if (errors.length > 0) {
      this.setState({ message: errors.join("\n"), severity: "error" })
    } else {
      this.setState(previousState => ({
        shipment: {
          ...previousState.shipment,
          features: {
            ...previousState.shipment.features,
            notifyToThirdParty: this.state.thirdPartyEmail
          }
        }
      }), () => {
        this.props.handleFeatures(this.state.shipment, this.props.index)
        this.setState({ openThirdPartyEmailModal: false })
      })
    }
  }

  doRemoveThirdPartyEmail = () => {
    this.setState(previousState => ({
      shipment: {
        ...previousState.shipment,
        features: {
          ...previousState.shipment.features,
          notifyToThirdParty: null
        }
      },
      thirdPartyEmail: null,
      repeatThirdPartyEmail: null
    }), () => {
      this.setState({ openThirdPartyEmailModal: false })
    })
  }

  /* ocr gives a reference after detecting it*/
  doDetectReference = (l, t, w, h) => {
    let draftid = this.state.shipment && this.state.shipment.pages.length > 0 ? this.state.shipment.pages[0].draftId : null
    let pageFirs = this.state.shipment && this.state.shipment.pages.length > 0 ? this.state.shipment.pages[0].pageFirst : 1
    if (!draftid) return

    this.setState({
      referenceLeft: l,
      referenceTop: t,
      referenceWidth: w,
      referenceHeight: h,
    }, () => {
      OutboxCli.DetectReferenceInPage(draftid,
        pageFirs,
        this.state.referenceLeft,
        this.state.referenceTop,
        this.state.referenceWidth,
        this.state.referenceHeight
      ).then(response => {
        if (response !== null && (response.toString().startsWith("[ERR") || response.toString().startsWith("<html>"))) {
          this.setState({ detectReferenceError: response.substring(response.indexOf(' ')) })
        } else {
          if (response.length > 0) {
            let reference = this.MultiSpace(response.replace("\t", " "), " ")
            this.setState(previousState => ({
              shipment: {
                ...previousState.shipment,
                features: {
                  ...previousState.shipment.features,
                  reference: reference
                }
              }
            }), () => { this.props.handleFeatures(this.state.shipment, this.props.index) })
              
          } else {
            this.setState({ message: localizer.NoReferenceDetected, severity: "info" })
          }
        }
        this.doCloseOcrReferenceModal()
      })
    })
  }

  // Replace two or more consecutive spaces with a single space
  MultiSpace(text) {
    return text.replace(/ {2,}/g, ' ');
  }

  handleonClose = () => {
    this.setState({ message: null })
  }

  mountDestinationAddress = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.destinationAddress) return ""
    
    let destinationaddress = this.state.shipment.destinationAddress.who + "\n" +
      this.state.shipment.destinationAddress.streetType + " " + this.state.shipment.destinationAddress.streetName + " " + this.state.shipment.destinationAddress.streetNumber + " " + this.state.shipment.destinationAddress.streetComplements + "\n" +
      this.state.shipment.destinationAddress.postalCode + " " + this.state.shipment.destinationAddress.locality
    return destinationaddress
  }

  getProductDescription = () => {
    let description = ""
    this.props.products && this.state.shipment.features && this.props.products.forEach(product => {
      if (product.productCode === this.state.shipment.features.productCode) {
        description = product.description
        return
      }
    })
    return description
  }

  /* Action menu handler */
  handleClickOptionsMenu = (event) => { this.setState({ optionsMenu: event.currentTarget, openMenu: true }) }
  handleOpenOptionsMenu = () => { this.setState({ openMenu: true }) }
  handleCloseOptionsMenu = () => { this.setState({ openMenu: false }) }
  
  render() {
    let left = this.state.referenceLeft
    let top = this.state.referenceTop
    let width = this.state.referenceWidth
    let height = this.state.referenceHeight
    let disabledOCR = this.props.billable && this.props.billable.billableOptions && this.props.billable.billableOptions.disabledOCR ? this.props.billable.billableOptions.disabledOCR : false

    const tooltip = this.state.shipment.features ? (this.state.shipment.features.reference ? this.state.shipment.features.reference : localizer.ShipmentReference) : localizer.ShipmentReference
    return (
      <React.Fragment>
        <TableRowStyled>
          <TableCellStyled align="center" style={{ width: '10%' }} className="typography-generic tablerow-content">{localizer.Shipment}  {this.props.index + 1} </TableCellStyled>
          <TableCellStyled align="center" style={{ width: '20%' }} className="typography-generic tablerow-content">
            {this.state.shipment.pages && this.state.shipment.pages.map((page) => {
              var documentName = ""
              var document = this.props.draftsSelected.find(draft => draft.draftId === page.draftId)
              if (document) { documentName = document.documentName }
              return (<Typography key={page.draftId + "-" + page.pageLast} className="typography-generic shipment-summary-docnames">{documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")\n"}</Typography>)
            })}
          </TableCellStyled>
          <TableCellStyled align="center" style={{ width: '20%' }} className="typography-generic tablerow-content">
            {this.state.shipment && this.state.shipment.features && this.state.shipment.features.productCode === "NT2" ?
              <TooltipStyled className="tooltip-custom-w" placement="top-end"
                title={
                  <Typography className="typography-generic small">{localizer.ShipmentNT2Restriction}</Typography>
                }>
                <Badge
                  badgeContent={<i className="fa-solid fa-warning"></i>}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  className="badge-warning"
                  style={{ width: "100%" }}>
                  <TextFieldStyled id={this.props.index + "$$refence"}
                    //label={<Typography className="typography-generic textinline">{localizer.ShipmentReference}</Typography>}
                    onChange={this.onInputChange} variant="outlined"
                    value={this.state.shipment.features ? this.state.shipment.features.reference : ""}
                    title={tooltip}
                    placeholder={localizer.ShipmentSumaryRefence}
                    InputProps={{
                      classes: {
                        input: "typography-generic textinline"
                      },
                      endAdornment:
                        <IconButton className="button-generic icon-button ml-25 p-0" disabled={disabledOCR} aria-label="OCR" onClick={this.doOpenOcrReferenceModal} >
                          {!disabledOCR && <i className="fa-solid fa-magnifying-glass"></i>}
                        </IconButton>
                    }}
                  />
                </Badge>
              </TooltipStyled>
              :
              <TextFieldStyled id={this.props.index + "$$refence"}
                //label={<Typography className="typography-generic textinline">{localizer.ShipmentReference}</Typography>}
                onChange={this.onInputChange} variant="outlined"
                value={this.state.shipment.features ? this.state.shipment.features.reference : ""}
                title={tooltip}
                placeholder={localizer.ShipmentSumaryRefence}
                InputProps={{
                  classes: {
                    input: "typography-generic textinline"
                  },
                  endAdornment:
                    <IconButton className="button-generic icon-button ml-25 p-0" disabled={disabledOCR} aria-label="OCR" onClick={this.doOpenOcrReferenceModal} >
                      {!disabledOCR && <i className="fa-solid fa-magnifying-glass"></i>}
                    </IconButton>
                }}
              />
            }
           
          </TableCellStyled>
          <TableCellStyled align="center" className="typography-generic tablerow-content white-space-pre">{this.mountDestinationAddress()}</TableCellStyled>
          <TableCellStyled align="center" className="typography-generic tablerow-content">{this.getProductDescription()}</TableCellStyled>
          <TableCellStyled align="center" className="typography-generic tablerow-content">{this.state.shipment.features ? CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, this.state.shipment.features.price / 100) : ""}</TableCellStyled>
          <TableCellStyled align="center" className="typography-generic tablerow-content">
            <Tooltip className="typography-generic" title={<Typography className="typography-generic">{localizer.ThirdPartyEmailSend}</Typography>}>
              <IconButton style={{ width: "20px", height: "20px" }} aria-label="more" aria-controls="shipment-options" aria-haspopup="true" onClick={() => this.setState({ openThirdPartyEmailModal: true })}>
                <i className="fa-solid fa-share-from-square font-size-20 mr-5"></i>
              </IconButton>
            </Tooltip>

            {/* <Menu id="page-options"
              anchorEl={this.state.optionsMenu}
              open={this.state.openMenu}
              onClose={this.handleCloseOptionsMenu}
              keepMounted
            >
              <MenuItem key="third-party-email-option" onClick={() => this.setState({ openThirdPartyEmailModal: true })}>
                <Typography className="typography-generic small"><i className="fa-regular fa-comment mr-5"></i>{localizer.ThirdPartyEmailSend}</Typography>
              </MenuItem>
            </Menu> */}
          </TableCellStyled>
        </TableRowStyled>
        {this.state.shipment && this.state.shipment.features && this.state.shipment.features.notifyToThirdParty &&
          <TableRowStyled>
            <TableCellStyled align="start" colSpan={7} className="typography-generic tablerow-content">
              <Alert severity="warning" icon={false} className="p-0">
                <Typography className="typography-generic">
                  <i className="fa-regular fa-comment mr-5"></i>
                  <strong>{this.state.shipment.features.notifyToThirdParty}</strong>
                  {localizer.ThirdPartyEmailNotifyTo}
                </Typography>
              </Alert>
            </TableCellStyled>
          </TableRowStyled>
        }

        {/* Third party email modal */}
        <Dialog
          open={this.state.openThirdPartyEmailModal}
          onClose={this.doCloseThirdPartyEmailModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          fullWidth
          maxWidth={"sm"}
        >
          <DialogTitle id="alert-dialog-title" className="bg-primary" style={{ color: "black" }}>
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.doCloseThirdPartyEmailModal}></i>
            <Typography className="typography-generic dialog-title"><i className="fa-regular fa-comment mr-5"></i>{localizer.ThirdPartyEmailSend}</Typography>
          </DialogTitle>
          <DialogContent dividers={true}>
            <Grid container item md={12}>
              <Alert severity="info">
                <AlertTitle>
                  <Typography className="typography-generic pt-0"><strong>{localizer.ThirdPartyEmailExplainTitle}</strong></Typography>
                </AlertTitle>
                <Typography className="typography-generic">{localizer.ThirdPartyEmailExplain}</Typography>
                <br></br>
                <ul>
                  <li><Typography className="typography-generic p-0">{localizer.ThirdPartyEmailExplain1}</Typography></li>
                  <li><Typography className="typography-generic p-0">{localizer.ThirdPartyEmailExplain2}</Typography></li>
                  <li><Typography className="typography-generic p-0">{localizer.ThirdPartyEmailExplain3}</Typography></li>
                </ul>
              </Alert>
            </Grid>
            <Grid container item md={12}>
              <Typography className="typography-generic">{localizer.ThirdPartyEmailDescription}</Typography>
            </Grid>
            <Grid container item md={12} className="mt-20">
              <TextFieldStyled id="thirdPartyEmail"
                label={<Typography className="typography-generic">{localizer.ThirdPartyEmail}</Typography>}
                name="thirdPartyEmail"
                value={this.state.thirdPartyEmail}
                onChange={this.onInputThirdEmailChange}
                onPaste={e => { e.preventDefault() }}
                variant="outlined" fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  classes: {
                    input: "typography-generic"
                  },
                  inputProps: { maxLength: 100 }
                }}
              />
            </Grid>
            <Grid container item md={12} className="mt-20">
              <TextFieldStyled id="repeatThirdPartyEmail"
                label={<Typography className="typography-generic">{localizer.RepeatEmail}</Typography>}
                name="repeatThirdPartyEmail"
                value={this.state.repeatThirdPartyEmail}
                onChange={this.onInputRepeatThirdEmailChange}
                onPaste={e => { e.preventDefault() }}
                variant="outlined" fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  classes: {
                    input: "typography-generic"
                  },
                  inputProps: { maxLength: 100 }
                }}
              />
            </Grid>
            <Grid item md={12} className="mt-10 float-right">
              <Button className="button-generic dialog-primary" variant="contained" onClick={this.doAcceptThirdPartyEmail}>{localizer.Accept}</Button>
              <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.doCloseThirdPartyEmailModal}>{localizer.Cancel}</Button>
              <Button className="button-generic dialog-delete float-left" variant="outlined" onClick={this.doRemoveThirdPartyEmail}>{localizer.Delete}</Button>
            </Grid>
          </DialogContent>
        </Dialog>
                  
        {/*  ORC Reference Modal  */}
        <FeatureModal openModal={this.state.openOcrReferenceModal} handleCloseModal={this.doCloseOcrReferenceModal} handleAcceptReference={this.doDetectReference}
          document={this.state.document} left={left} top={top} width={width} height={height}></FeatureModal>
        
        {/* Detect reference error. */}
        <SnackbarCustom message={this.state.message} severity={this.state.severity} handleonClose={this.handleonClose} />
       

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/shipments/sections/features/FeatureRow.js